// ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenStatus } from './auth';

const ProtectedRoute = ({ element }) => {
    const location = useLocation();
    // Rent oppslag (ingen bivirkning, rører aldri localStorage) - med vilje,
    // så svaret er stabilt selv om React StrictMode i utvikling kjører denne
    // komponenten gjennom en ekstra mount→effekt→unmount→mount-runde. Selve
    // oppryddingen av et utløpt token skjer i Login.js i stedet, som er et
    // stabilt sluttpunkt og ikke en del av den dansen.
    const status = tokenStatus();

    return status === 'gyldig'
        ? element
        : <Navigate to="/login" state={{ from: location, reason: status === 'utløpt' ? 'expired' : undefined }} replace />;
};

export default ProtectedRoute;
